import { defineStore } from 'pinia';
import profileService from '../services/profileService.js';

export const useProfileStore = defineStore('profile', {
  state: () => ({
    professionalProfile: null,
    groupSubjects: {},
    isLoading: false,
    isSaving: false,
    error: null,
  }),
  actions: {
    async fetchProfile() {
      this.isLoading = true;
      this.error = null;
      try {
        const response = await profileService.getProfessionalProfile();
        console.log('Fetched profile data:', response);
        this.professionalProfile = response;
      } catch (error) {
        this.error = error;
      } finally {
        this.isLoading = false;
      }
    },
    async saveProfile(newProfileData) {
      this.isLoading = true;
      this.error = null;
      try {
        await profileService.updateProfessionalProfile(newProfileData);
        this.professionalProfile = { ...this.professionalProfile, ...newProfileData };
        return true;
      } catch (error) {
        this.error = error;
        return false;
      } finally {
        this.isLoading = false;
      }
    },
    async fetchGroupSubjects() {
      this.isLoading = true;
      try {
        const response = await profileService.getGroupSubjects();
        this.groupSubjects = response || {};
      } catch (error) {
        console.error('Failed to fetch group subjects:', error);
        this.error = error;
      } finally {
        this.isLoading = false;
      }
    },
    async updateGroupSubjects(newGroupSubjects) {
      this.isSaving = true;
      try {
        await profileService.updateGroupSubjects(newGroupSubjects);
        this.groupSubjects = newGroupSubjects;
      } catch (error) {
        console.error('Failed to update group subjects:', error);
        this.error = error;
        // Optionally re-throw or handle for the UI
      } finally {
        this.isSaving = false;
      }
    },
    clearProfile() {
      this.professionalProfile = null;
      this.groupSubjects = {};
      this.isLoading = false;
      this.isSaving = false;
      this.error = null;
    },
  },
  getters: {
    hasProfileData: (state) => !!state.professionalProfile,
  },
});
